"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerAppBarPanes = exports.App = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _Fabric = require("@fluentui/react/lib/Fabric");

var React = _interopRequireWildcard(require("react"));

var _connectedReactRouter = require("connected-react-router");

var _FeatureFlagPane = require("../../FeatureFlags/FeatureFlagPane");

var _models = require("../../FeatureFlags/models");

var _CardNotificationPanel = require("../../Notifications/CardNotificationPanel");

var _dialogRegistry = require("../../Notifications/dialogRegistry");

var _models2 = require("../../Notifications/models");

var _HelpPane = require("../../Options/HelpPane");

var _models3 = require("../../Options/models");

var _OptionsPane = require("../../Options/OptionsPane");

var _UserActions = require("../../User/models/UserActions");

var _ConnectedLoadableApp = require("./ConnectedLoadableApp");

/**
 * The App control represents an arrange of common set of app features such as routing and state management
 * as well as a standard layout (left nav and app bar)
 */
var App = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(App, _React$Component);

  var _super = (0, _createSuper2.default)(App);

  function App(nextProps) {
    var _this;

    (0, _classCallCheck2.default)(this, App);
    _this = _super.call(this, nextProps);
    registerAppBarPanes();
    return _this;
  }

  (0, _createClass2.default)(App, [{
    key: "render",
    value: function render() {
      var history = this.props.history;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Fabric.Fabric, {
        hidden: this.props.hidden,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_connectedReactRouter.ConnectedRouter, {
          history: history,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConnectedLoadableApp.ConnectedLoadableApp, (0, _objectSpread2.default)({}, this.props))
        })
      });
    }
  }]);
  return App;
}(React.Component);

exports.App = App;

var registerAppBarPanes = function registerAppBarPanes() {
  _dialogRegistry.dialogRegistry.addDialog({
    dialogAction: _models3.OptionsActions.showHelp,
    component: _HelpPane.ConnectedHelpPane
  });

  _dialogRegistry.dialogRegistry.addDialog({
    dialogAction: _models.FeatureFlagsActions.showFeatureFlags,
    component: _FeatureFlagPane.ConnectedFeatureFlagPane
  }); // The some panes need parameters, so they are only registered as an action here


  _dialogRegistry.dialogRegistry.addAction(_UserActions.UserActions.showMe);

  _dialogRegistry.dialogRegistry.addAction(_UserActions.UserActions.showTenantPicker);

  if (process.env.APP_ENABLE_NOTIFICATIONS === 'true') {
    _dialogRegistry.dialogRegistry.addDialog({
      dialogAction: _models2.NotificationsActions.showCardNotificationPanel,
      component: _CardNotificationPanel.ConnectedCardNotificationPanel
    });
  }

  if (process.env.APP_ENABLE_OPTIONS === 'true') {
    _dialogRegistry.dialogRegistry.addDialog({
      dialogAction: _models3.OptionsActions.showOptions,
      component: _OptionsPane.ConnectedOptionsPane
    });
  }
};

exports.registerAppBarPanes = registerAppBarPanes;